<div class="f-row custom-dialog" [formGroup]="otpForm">
  <div class="container d-justify-bw">
    <div class="verify-title">
      <div class="title">
        <h3 class="title-text">{{ data?.showStepLabel !== false ? 'Step ' + step + ' of ' + totalSteps + ' - ' : '' }}{{ verifyMode === 'mobile' ? 'Verify your phone number' : 'Verify your email address' }}</h3>
        <span class="sub-title">
          {{ infoMessage }}
          <span class="title-variable">{{ maskedEmail }}</span>
        </span>
      </div>
      <div class="close">
        <button mat-icon-button (click)="onCancel()">
          <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
        </button>
      </div>
    </div>

    <div class="f-col d-align-center verify-body">
      <div class="f-col app-input-100w">

        <div class="f-row otp-inputs">
          <mat-form-field class="otp-validate" *ngFor="let ctrlName of digitControlNames; let i = index"
            [ngClass]="{ 'error-field': otpForm.get(ctrlName)?.hasError('incorrect') }">
            <input matInput type="tel" [formControlName]="ctrlName" [id]="ctrlName" maxlength="1" inputmode="numeric"
              pattern="[0-9]*" (keypress)="allowNumbersOnly($event)" (input)="moveNext($event, i)"
              (keydown.backspace)="movePrev($event, i)" />
          </mat-form-field>
        </div>

        <span class="sub-title p-top-6x" [ngStyle]="{ color: 'red' }" *ngIf="showErrorMsg">
          {{ showErrorMsg }}
        </span>

        <div class="p-top-12x text-center">
          <span class="sub-title" *ngIf="showTimer">
            Resend code in <span class="title-variable">{{ countdown }}</span>
          </span>
          <span class="sub-title" *ngIf="!showTimer && resendAttemptsLeft > 0">
            <a class="cursor-pointer" tabindex="0" role="button" (keydown.enter)="onResendCodeClick()" (click)="onResendCodeClick()">
              {{ content?.['b2b.register.resendcode'] || 'Resend code' }}
            </a>
          </span>
          <!-- <div class="sub-title p-top-6x">
            You have <span class="title-variable">{{ resendAttemptsLeft }}</span> resend attempts left.
          </div> -->
        </div>
      </div>
    </div>

    <div class="f-col d-align-right verify-footer">

      <button mat-button class="button--primary-small" (click)="onVerify()"
        [disabled]="!isOtpComplete || isVerifying || invalidOtpAttemptsLeft <= 0">
        <mat-spinner *ngIf="isVerifying" diameter="20" class="button-spinner"></mat-spinner>
        {{ getRegisterWarning('b2b.register.resendcode')?.confirmCTAText || 'Verify' }}
      </button>
    </div>
  </div>
</div>